import classNames from 'classnames';
import React from 'react';
import { ButtonProps } from '../../types/components/button';
import './Button.css';
import { CircularProgress } from '@mui/material';

const SquareButton: React.FC<ButtonProps> = ({ onClick, label, small, leftSpace, rightSpace, bold, color, fullWidth, disabled, icon, selected, isLoading, e2eTestId }) => {
    return (
        <button 
          onClick={onClick}
          disabled={disabled}
          className={
            classNames(
                'square-button',
                { 
                    'small': small, 
                    'medium': !small,
                    'margin-left': leftSpace,
                    'mergin-right': rightSpace,
                    'bold': bold,
                    [color??'primary' as string]: color??'primary',
                    'full-width': fullWidth,
                    'selected': selected,
                    'disabled': disabled || isLoading
                }
            )
          }
          data-e2e-test-id={e2eTestId}
        >
            {
                isLoading ?
                    <CircularProgress size={20} color='inherit' />
                    :
                    <>
                        {icon && icon}
                        {label}
                    </>
            }
        </button>
    );
};

export default SquareButton;
